import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Icon,
  IconButton,
  Menu,
  MenuList,
  MenuItem,
  ListItemText,
  ListSubheader,
  Checkbox,
  Tooltip,
  Fab,
} from '@material-ui/core';
import { getStatuses } from '@pingum/app-state-management/status/actions';
import { showLogsModal } from '@pingum/app-state-management/log/actions';
import { maxBy } from 'lodash';
import { getTenantFromUrl } from '../../../../../utils/urlHelper';
import AuditLogsButton from '../../../../widgets/AuditLogsButton';
import StatusEditor from '../StatusEditor';
import styles from './styles';

const newEmptyStatus = {
  icon: 'bookmark',
  iconColor: '#000000',
  name: 'New Status',
};

export class StatusSettingsHeaderComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      includeArchived: props.includeArchived,
      showAddStatus: false,
    };
  }

  handleAddStatusClick = () => {
    this.setState({ showAddStatus: true });
  }

  handleIncludeArchivedChanged = () => {
    this.setState((prevState) => ({ includeArchived: !prevState.includeArchived }), () => {
      this.props.getStatuses(this.state.includeArchived);
    });
  }

  handleSettingsClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleSettingsClose = () => {
    this.setState({ anchorEl: null });
  }

  handleStatusSave = (emptyId, newStatusRequest) => {
    this.props.onAddStatus({
      ...newEmptyStatus,
      ...newStatusRequest,
      statusOrder: maxBy(this.props.statuses.length === 0
        ? [{ statusOrder: 0 }]
        : this.props.statuses, 'statusOrder').statusOrder + 1,
    });
  }

  handleAddStatusModalClose = () => {
    this.setState({ showAddStatus: false });
  }

  showLogsModal = () => {
    this.props.showLogsModal({
      tenantName: getTenantFromUrl(),
      service: 'event',
      actions: ['Create Status', 'Update Status'],
    });
  }

  render() {
    const { onShowInfoModal } = this.props;
    const {
      anchorEl,
      includeArchived,
      showAddStatus,
    } = this.state;

    return (
      <div style={styles.statusSettingsTitleContainer}>
        {
          showAddStatus
            && (
              <StatusEditor
                status={newEmptyStatus}
                editStatus={this.handleStatusSave}
                onClose={this.handleAddStatusModalClose}
              />
            )
        }
        <h3
          style={styles.statusSettingsTitle}
          className="event-status-page-title"
        >
          Event Statuses
        </h3>
        <div style={styles.statusSettingsActionsContainer}>
          <Tooltip title="Add New Status">
            <Fab
              color="primary"
              aria-label="add"
              onClick={this.handleAddStatusClick}
              size="medium"
              style={styles.addButton}
            >
              <Icon>add</Icon>
            </Fab>
          </Tooltip>
          <Tooltip title="More Actions" id="status-more-actions-tooltip">
            <IconButton
              onClick={this.handleSettingsClick}
              className="more-actions-button"
            >
              <Icon>more_vert</Icon>
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleSettingsClose}
          >
            <ListSubheader>
              More actions
            </ListSubheader>
            <MenuList>
              <MenuItem
                onClick={this.handleIncludeArchivedChanged}
                button
                id="include-archived-statuses-button"
              >
                <Checkbox
                  disableRipple
                  checked={includeArchived}
                />
                <ListItemText primary="Include archived" />
              </MenuItem>
              <MenuItem
                onClick={onShowInfoModal}
                button
                id="about-statuses-button"
              >
                <IconButton disableRipple>
                  <Icon>info_outline</Icon>
                </IconButton>
                <ListItemText primary="About statuses" />
              </MenuItem>
              <MenuItem
                onClick={this.showLogsModal}
                button
                id="show-logs-button"
              >
                <AuditLogsButton />
                <ListItemText primary="View Audit Logs" />
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
      </div>
    );
  }
}

StatusSettingsHeaderComponent.propTypes = {
  onShowInfoModal: PropTypes.func,
  getStatuses: PropTypes.func,
  includeArchived: PropTypes.bool,
  showLogsModal: PropTypes.func,
  onAddStatus: PropTypes.func,
  statuses: PropTypes.array,
};

StatusSettingsHeaderComponent.defaultProps = {
  onShowInfoModal: () => {},
  getStatuses: () => {},
  includeArchived: false,
  showLogsModal: () => {},
  onAddStatus: () => {},
  statuses: [],
};

export const mapStateToProps = (state) => ({
  includeArchived: state.status.includeArchived,
  statuses: state.status.statuses,
});

export const mapDispatchToProps = (dispatch) => ({
  getStatuses: (includeArchived) => dispatch(getStatuses(includeArchived)),
  showLogsModal: (request) => dispatch(showLogsModal(request)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StatusSettingsHeaderComponent);
